import React from "react";
import {DateTime} from "../tools/delivery-tools";
import {REDUCTION_TYPE} from "../../helpers/delivery.helper";
import i18n from "i18next";

export const TenderInfo = {
  common,
  price
}

function common({delivery}) {
  const tender = delivery.Tender;
  const isReduction = (delivery.Type === REDUCTION_TYPE);
  const isMultimodal = (delivery.IsMultimodal);
  let info = [];

  if (tender.LoadStart && tender.LoadEnd) {
    info.push(<>
      <div className="h-informer">{i18n.t('components.tender.loadInterval')}</div>
      <div className="b-informer">
        <div className="date red">{tender.LoadInterval}</div>
      </div>
    </>);
  }

  if (tender.TenderStart && tender.TenderEnd) {//TODO китайская версия - проверить!!
    info.push(<>
      <div className="h-informer">{isReduction ? i18n.t('components.tender.interval.variant.reduction') : i18n.t('components.tender.interval.variant.auction')}</div>
      <div className="b-informer" style={{textAlign: "left"}}>
        <div className="date green"><b>{i18n.t('components.tender.tenderStart')}</b> <DateTime date={tender.TenderStart}/></div>
        <div className="date green"><b>{i18n.t('components.tender.tenderEnd')}</b> <DateTime date={tender.TenderEnd}/></div>
      </div>
    </>);
  }

  return info;
}

function price({delivery}) {
  const tender = delivery.Tender;
  let info = [];

  if (tender.MaxPrice && tender.Step && false) { //Раз показываем ценой, эти данные не нужны
    info.push(<>
      <div className="col-pos-bot">
        <div className="double-bot clrfx">
          <div className="informer-item">
            <div className="h-informer">{i18n.t('components.tender.maxPrice')}</div>
            <div className="b-informer">
              <div className="inf">{tender.MaxPrice}</div>
            </div>
          </div>
          <div className="informer-item">
            <div className="h-informer">{i18n.t('components.tender.actualPrice')}</div>
            <div className="b-informer">
              <div className="inf">{tender.ActualPrice}</div>
            </div>
          </div>
        </div>
      </div>
    </>);
  }

  return info;
}
